/**
 * Tilled Admin API
 *
 * Contact: integrations@tilled.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BalanceTransaction } from './balanceTransaction';


export interface AdminPayout { 
    account_id: string;
    /**
     * The name of the account associated with this Payout.
     */
    account_name?: string;
    /**
     * ACH Settlement Reference ID
     */
    ach_settlement_ref_id?: string;
    /**
     * Amount to be transferred to your bank account, in the smallest currency unit (e.g., 100 cents to charge $1.00 or 100 to charge ¥100, a zero-decimal currency).
     */
    amount: number;
    /**
     * The balance amount (in minor units) brought forward from the previous statement.
     */
    balance_brought_forward_amount?: number;
    /**
     * The balance amount (in minor units) carried forward to the next statement.
     */
    balance_carried_forward_amount?: number;
    /**
     * The balance transaction that describes the impact of this payout on your account balance. Note: Multiple balance transactions may be associated with this resource and you can fetch them all with `/balance-transactions?source_id={id}`.
     * @deprecated
     */
    balance_transaction: BalanceTransaction;
    /**
     * The Batch (`bch_*`) whose manual close eventually produced this payout. Populated forward-only, after the processor\'s settlement reporting has been consumed: - Falcon-mirror TSYS / Multi Pass / Valor CP: set by the payout-creating handler for `TsysBatchSettledEvent`. - Kort: set by the `PayoutPaidEvent` consumer from the field the tsys module publishes on the event. Null on legacy payouts and on payouts that don\'t correspond to a manual-close batch.
     */
    batch_id?: string | null;
    /**
     * The calculated amount of the payout (in minor units). _`calculated_payout_amount` = `balance_carried_forward_amount` + `sum_transactions_amount` - `balance_brought_forward_amount`_
     */
    calculated_payout_amount?: number;
    /**
     * Time at which the object was created.
     */
    created_at: string;
    /**
     * Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase.
     */
    currency: AdminPayout.CurrencyEnum;
    /**
     * Number of days in arrears.
     */
    days_in_arrears?: number;
    /**
     * An arbitrary string attached to the object. Often useful for displaying to users.
     */
    description?: string;
    /**
     * Error code explaining the reason for a payout failure, if available.
     */
    failure_code?: AdminPayout.FailureCodeEnum;
    /**
     * Unique identifier for the object.
     */
    id: string;
    /**
     * The date the payout was paid.
     */
    paid_at?: string;
    /**
     * The total transaction amount (in minor units) for the current statement period. This amount should match the sum of `sum_transactions_amount` and `balance_brought_forward_amount`.
     */
    statement_period_amount?: number;
    /**
     * The end of the billing period for this payout.
     */
    statement_period_end?: string;
    /**
     * The start of the billing period for this payout.
     */
    statement_period_start?: string;
    /**
     * Current status of the payout: `paid`, `pending`, `in_transit`, `canceled` or `failed`. A payout is `pending` until it is submitted to the bank, when it becomes `in_transit`. The status then changes to `paid` if the transaction goes through, or to `failed` or `canceled` (within 5 business days). Some failed payouts may initially show as `paid` but then change to `failed`.
     */
    status: AdminPayout.StatusEnum;
    /**
     * The sum (in minor units) of the individual transactions associated to this payout.
     */
    sum_transactions_amount?: number;
    /**
     * An optional property that is included when specified in a query parameter on request. It represents the number of balance_transaction objects associated with the payout (aside from the payout balance transaction itself).
     */
    transaction_count?: number;
    /**
     * Time at which the object was last updated.
     */
    updated_at: string;
}
export namespace AdminPayout {
    export type CurrencyEnum = 'aud' | 'cad' | 'dkk' | 'eur' | 'hkd' | 'jpy' | 'nzd' | 'nok' | 'gbp' | 'zar' | 'sek' | 'chf' | 'usd';
    export const CurrencyEnum = {
        AUD: 'aud' as CurrencyEnum,
        CAD: 'cad' as CurrencyEnum,
        DKK: 'dkk' as CurrencyEnum,
        EUR: 'eur' as CurrencyEnum,
        HKD: 'hkd' as CurrencyEnum,
        JPY: 'jpy' as CurrencyEnum,
        NZD: 'nzd' as CurrencyEnum,
        NOK: 'nok' as CurrencyEnum,
        GBP: 'gbp' as CurrencyEnum,
        ZAR: 'zar' as CurrencyEnum,
        SEK: 'sek' as CurrencyEnum,
        CHF: 'chf' as CurrencyEnum,
        USD: 'usd' as CurrencyEnum
    };
    export type FailureCodeEnum = 'account_closed' | 'account_frozen' | 'bank_account_restricted' | 'bank_ownership_changed' | 'could_not_process' | 'debit_not_authorized' | 'declined' | 'invalid_account_number' | 'incorrect_account_holder_name' | 'incorrect_account_holder_address' | 'incorrect_account_holder_tax_id' | 'invalid_currency' | 'no_account';
    export const FailureCodeEnum = {
        ACCOUNT_CLOSED: 'account_closed' as FailureCodeEnum,
        ACCOUNT_FROZEN: 'account_frozen' as FailureCodeEnum,
        BANK_ACCOUNT_RESTRICTED: 'bank_account_restricted' as FailureCodeEnum,
        BANK_OWNERSHIP_CHANGED: 'bank_ownership_changed' as FailureCodeEnum,
        COULD_NOT_PROCESS: 'could_not_process' as FailureCodeEnum,
        DEBIT_NOT_AUTHORIZED: 'debit_not_authorized' as FailureCodeEnum,
        DECLINED: 'declined' as FailureCodeEnum,
        INVALID_ACCOUNT_NUMBER: 'invalid_account_number' as FailureCodeEnum,
        INCORRECT_ACCOUNT_HOLDER_NAME: 'incorrect_account_holder_name' as FailureCodeEnum,
        INCORRECT_ACCOUNT_HOLDER_ADDRESS: 'incorrect_account_holder_address' as FailureCodeEnum,
        INCORRECT_ACCOUNT_HOLDER_TAX_ID: 'incorrect_account_holder_tax_id' as FailureCodeEnum,
        INVALID_CURRENCY: 'invalid_currency' as FailureCodeEnum,
        NO_ACCOUNT: 'no_account' as FailureCodeEnum
    };
    export type StatusEnum = 'canceled' | 'failed' | 'in_transit' | 'paid' | 'pending';
    export const StatusEnum = {
        CANCELED: 'canceled' as StatusEnum,
        FAILED: 'failed' as StatusEnum,
        IN_TRANSIT: 'in_transit' as StatusEnum,
        PAID: 'paid' as StatusEnum,
        PENDING: 'pending' as StatusEnum
    };
}


